module.exports = __webpack_public_path__ + "img/appqrcode.130032f8.png";